// extracted by mini-css-extract-plugin
export default {"sidebarContainer":"VendorsIndex_sidebarContainer__JhIkO","bodyContainer":"VendorsIndex_bodyContainer__3EcSx"};